import avatars from '@/store/helpers/avatar-options'
import * as MutationTypes from './mutation-types'

export default {
  state: {
    avatars: []
  },
  mutations: {
    [MutationTypes.SET_AVATARS] (state, avatars) {
      state.avatars = avatars
    }
  },

  actions: {
    initAvatars ({ commit }) {
      commit(MutationTypes.SET_AVATARS, avatars)
    }
  },

  getters: {
    getAvatars (state) {
      return state.avatars
    }

  }
}
